<template>
  <div id="main-content" class="edit-sub-driver">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8"><span class="required-star">* </span><span class="form-lable">{{ $t('common.category') }}</span></el-col>
            <input class="input" v-model="categoryInfo.name" type=""/>
          </el-col>
        </el-row>
        <el-row style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '../../components/PageTitle.vue'
  import {mapState} from 'vuex'

  export default {
    name: "EditBusNotificationCategory",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: `/bus-notification-template/detail-category?cid=${this.$route.query.cid}`,
        title: this.$t('common.edit_category'),
      }
    },
    mounted: function () {
      let successCallback = () => {
      };
      let payload = {
        successCallback,
        bus_notification_category_id: this.$route.query.cid
      }
      this.$store.dispatch('busnotificationtemplate/getBusNotificationCategoryInfo', payload)
    },
    computed: {
      ...mapState('busnotificationtemplate', ['categoryInfo']),
    },
    methods: {
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.$router.push({path: '/bus-notification-template/detail-category', query: {cid: this.$route.query.cid}});
          }
          let payload = {
            successCallback,
            data: this.categoryInfo,
            bus_notification_category_id: this.$route.query.cid
          }
          this.$store.dispatch('busnotificationtemplate/updateBusNotificationCategory', payload);
        }
      },
      validate: function () {
        return true
      },
    }
  }
</script>

<style scoped>

</style>